export default "__VITE_ASSET__8fd328c8__"